import { useEffect, useState } from 'react';

export const PLAYBOOK_HISTORY_KEY = 'playbookViewHistory';

const readHistory = (): number[] => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(PLAYBOOK_HISTORY_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'number') : [];
  } catch {
    return [];
  }
};

/**
 * Records the playbooks viewed in this browser session and returns the one viewed
 * before the current playbook ("Prev Play"), or undefined when there isn't one.
 * Arriving via Prev Play (`cameFromPrev`) pops the playbook we left, so Prev can be pressed
 * repeatedly. Any other visit is appended, even one that wraps back to an earlier playbook.
 */
export function usePlaybookHistory(
  contentId: number | undefined,
  cameFromPrev = false,
): number | undefined {
  const [prevId, setPrevId] = useState<number>();

  useEffect(() => {
    if (contentId === undefined) return;
    const history = readHistory();
    const last = history[history.length - 1];
    if (cameFromPrev && history[history.length - 2] === contentId) {
      history.pop(); // stepped back to the previous playbook
    } else if (last !== contentId) {
      history.push(contentId);
    }
    sessionStorage.setItem(PLAYBOOK_HISTORY_KEY, JSON.stringify(history));
    setPrevId(history[history.length - 2]);
  // cameFromPrev is read with the new contentId; it never changes on its own
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentId]);

  return prevId;
}
